'use strict';

module.exports = {
    /**
     * 打开新的webView
     * @method hysdk.openWebView
     * @category Fusion:WebView
     * @description
     * * 只支持 url、name、type 参数。
     * * url 支持 http/https 或携程模块页面地址，例如 `car/index.html`
     * * type 支持 navibar-normal 和 navibar-none
     */
    openWebView: {
        service: 'Util',
        action: 'openUrl',
        tagname: 'open_url',
        optHandle: function optHandle(opt) {
            var option = {
                openUrl: opt.url
            };
            //@hongqi.gan 允许自定义mode
            option.targetMode = opt.targetMode || opt.url.indexOf('://') > -1 ? 2 : 4;
            option.pageName = opt.name;
            option.meta = {
                isHideNavBar: opt.type === 'navibar-none'
            };
            return option;
        }
    },
    /**
     * 关闭当前view
     * @method hysdk.closeWebView
     * @category Fusion:WebView
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    closeWebView: {
        exec: function exec(opt, callback) {
            if (opt.name) {
                this.bridge.invoke('Page', 'backToPage', {
                    pageName: opt.name,
                    callbackString: opt.data ? JSON.stringify(opt.data) : ''
                }, 'back_to_page', callback);
            } else {
                this.bridge.invoke('Util', 'backToLast', {
                    callbackString: opt.data ? JSON.stringify(opt.data) : ''
                }, 'back_to_last_page', callback);
            }
        }
    },
    /**
     * 设置当前view的属性
     * @method hysdk.setWebViewAttr
     * @category Fusion:WebView
     * @description
     * 只支持配置 name 属性
     */
    setWebViewAttr: {
        service: 'Page',
        action: 'setPageName',
        tagname: 'set_page_name',
        optHandle: function optHandle(opt) {
            return {
                pageName: opt.name
            };
        }
    },
    getInitData: false,
    /**
     * 设置状态栏颜色
     * @method hysdk.setStatus
     * @category Fusion:WebView
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    setStatus: {
        service: 'Util',
        action: 'setStatusBarStyle',
        tagname: 'set_status_bar_style',
        optHandle: function optHandle(opt) {
            return {
                statusBarStyle: opt.style === 'light' ? 'lightContent' : 'darkContent'
            };
        },
        resHandle: function resHandle(res, opt) {
            return {
                style: opt.style
            };
        }
    },
    /**
     * 设置webview是否支持ios的后退手势
     * @method hysdk.enableBackGesture
     * @category Fusion:WebView
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    enableBackGesture: {
        service: 'Page',
        action: 'enableDragAnimation',
        tagname: 'enable_drag_animation',
        optHandle: function optHandle(opt) {
            return {
                isEnable: !!opt.enable
            };
        }
    },
    /**
     * 隐藏load页面
     * @method hysdk.hideLoadView
     * @category Fusion:WebView
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    hideLoadView: {
        service: 'Page',
        action: 'hideLoadingPage',
        tagname: 'hide_loading_page'
    },
    getHistory: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/webview.js
// module id = 50
// module chunks = 1 4